import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getInventoryCountFilteredData } from '../../services/inventoryCountService';

export default function FilterModal({onClose , data}) {
    const { t } = useTranslation();
    const dispatch =useDispatch();

    const [filteredData, setFilteredData] = useState(data);
    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        BranchName: "",
        Status: "",
      });

      const handleFilterInventoryCount = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { BranchName , Status } = filterCriteria;
    
          let filterBranchName = true;
          let filterStatus = true;
    
          if (BranchName) {
            filterBranchName = item.BranchName.toLowerCase().includes(BranchName.toLowerCase());
          }
    
          if (Status) {
            filterStatus = item.Status.toLowerCase().includes(Status.toLowerCase());
          }

          return (
            filterBranchName &&
            filterStatus 
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getInventoryCountFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.inventory_count.inventory_count_filter")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterInventoryCount}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.inventory_count.branch_name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.inventory_count.branch_name")}
                name="BranchName"
                value={filterCriteria.BranchName}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    BranchName: e.target.value,
                  })
                }
              />
              <Input
                label={t("pages.inventory_count.status")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.inventory_count.status")}
                name="Status"
                value={filterCriteria.Status}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Status: e.target.value,
                  })
                }
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
}
